import { useEffect } from 'react'
import { useVisitorRealTime } from './Visitor'
import { useWidgetOpen } from '../../../utils'
import { useConversationRealTime } from './Conversation'
import { useEventEmitter } from '../../../utils/EventEmitter'

export function RealtimeUpdatesWorker(): null {
  const eventEmitter = useEventEmitter()
  const { setOpen } = useWidgetOpen()

  useVisitorRealTime()
  useConversationRealTime()

  useEffect(() => {
    function onOpen() {
      setOpen(true)
    }

    eventEmitter.on('__widget_open', onOpen)
    return () => {
      eventEmitter.off('__widget_open', onOpen)
    }
  }, [eventEmitter, setOpen])

  return null
}
